import React from "react";
import I18nServicePage from "@/components/I18nServicePage";
import DoWeJourney from "@/components/DoWeJourney";
import { IMG } from "@/lib/config";

export default function EcoleManagement() {
  return (
    <I18nServicePage
      i18nKey="ecole"
      image={IMG.ecole}
      testIdPrefix="ecole"
      accentClass="text-accent-lime"
      afterSections={<DoWeJourney />}
    />
  );
}
